'use client';

import React, { useState } from 'react';
import Loading from 'components/commercetools-ui/atoms/loading';
import Link from 'next/link';

interface SmartLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  showLoader?: boolean;
  prefetch?: boolean;
  callback?: any;
  reload?: boolean;
  className?: string;
  target?: string;
}

export const SmartLink: React.FC<SmartLinkProps> = ({
  href,
  showLoader = true,
  prefetch = false,
  callback,
  className,
  children,
  reload = true,
  target,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Allow open in new tab/window or right/middle clicks

    if (callback !== undefined) {
      callback();
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    if (showLoader) setIsLoading(true);
    if (reload === false) {
      window.history.pushState(null, '', href); // used for not to reload the page
    } else {
      requestAnimationFrame(() => {
        window.location.href = href;
      });
    }
  };

  return (
    <div className="relative">
      <Link href={href} onClick={handleClick} prefetch={prefetch} target={target} {...rest} className={className}>
        {children}
      </Link>

      {isLoading && (
        <div className="absolute left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-white/70">
          <Loading />
        </div>
      )}
    </div>
  );
};
